/** @format */

import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import type { EventsListResponse } from 'src/types';

const initialState = {
  eventsLoading: false,
  events: null,
  eventDetailLoading: false,
  eventDetail: null,
  eventArticlesLoading: null,
  eventArticles: null,
  categoriesLoading: false,
  categories: null,
  updateEventsLoading: false,
  ratingSuccess: false,
  ratingError: null,
  error: null
};

const slice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    getEvents(state) {
      state.eventsLoading = true;
    },
    getEventsSuccess(state, action) {
      const data = action.payload;
      state.events = data || [];
      state.eventsLoading = false;
    },
    getEventsFailure(state, action) {
      state.error = action.payload;
      state.eventsLoading = false;
    },
    getEventArticles(state) {
      state.eventArticlesLoading = true;
    },
    getEventArticlesSuccess(state, action) {
      const data = action.payload;
      state.eventArticles = Array.isArray(data) ? data : data?.events || [];
      state.eventArticlesLoading = false;
    },
    getEventArticlesFailure(state, action) {
      state.error = action.payload;
      state.eventArticlesLoading = false;
    },
    getCategories(state) {
      state.categoriesLoading = true;
    },
    getCategoriesSuccess(state, action) {
      const data = action.payload;
      state.categories = data.categories || [];
      state.categoriesLoading = false;
    },
    getCategoriesFailure(state, action) {
      state.error = action.payload;
      state.categoriesLoading = false;
    },
    getEventDetail(state) {
      state.eventDetailLoading = true;
    },
    getEventDetailSuccess(state, action) {
      const data = action.payload;
      state.eventDetailLoading = false;
      state.eventDetail = data;
    },
    getEventDetailFailure(state, action) {
      state.error = action.payload;
      state.eventDetailLoading = false;
    },
    rateArticle(state) {
      state.eventDetailLoading = true;
    },
    rateArticleSuccess(state) {
      state.ratingSuccess = true;
      state.eventDetailLoading = false;
    },
    rateArticleFailure(state, action) {
      state.eventDetailLoading = false;
      state.ratingError = action.payload.error;
    },
    clearEventsError(state) {
      state.error = null;
      state.ratingError = null;
      state.ratingSuccess = false;
    },
    resetEventsError(state, action) {
      state.error = action.payload;
      state.eventsLoading = false;
    },
    setEventTitle(state, action) {
      state.eventDetail = { title: action.payload };
    }
  }
});

export const reducer = slice.reducer;

export const getEvents = id => async dispatch => {
  const { getEvents, getEventsSuccess, getEventsFailure } = slice.actions;

  try {
    dispatch(getEvents());
    // TODO: The endpoint not ready yet
    // const response = await axios.get(`${ENDPOINTS.GET_EVENTS_ENDPOINT}/${id}/`);
    // dispatch(getEventsSuccess(response.data));
    dispatch(getEventsSuccess({ id: 3, title: 'General', body: '', categories: [{ id: 73, name: 'General' }] }));
  } catch (err) {
    dispatch(getEventsFailure(err));
  }
};

export const getEventArticles = params => async dispatch => {
  const { getEventArticles, getEventArticlesSuccess, getEventArticlesFailure } = slice.actions;

  try {
    dispatch(getEventArticles());
    const response = await axios.get<EventsListResponse>(`${ENDPOINTS.GET_EVENTS_ENDPOINT}/`, { params });
    dispatch(getEventArticlesSuccess(response.data));
  } catch (err) {
    dispatch(getEventArticlesFailure(err));
  }
};

export const getEventCategories = () => async dispatch => {
  const { getCategories, getCategoriesSuccess, getCategoriesFailure } = slice.actions;

  try {
    dispatch(getCategories());
    const response = await axios.get(`${ENDPOINTS.GET_EVENTS_CATEGORIES_ENDPOINT}`);
    dispatch(getCategoriesSuccess(response.data));
  } catch (err) {
    dispatch(getCategoriesFailure(err));
  }
};

export const getEventDetail = (id, noLoad) => async dispatch => {
  const { getEventDetail, getEventDetailSuccess, getEventDetailFailure } = slice.actions;

  try {
    if (!noLoad) dispatch(getEventDetail());
    const response = await axios.get(`${ENDPOINTS.GET_EVENTS_ENDPOINT}/${id}`);
    dispatch(getEventDetailSuccess(response.data));
  } catch (err) {
    dispatch(getEventDetailFailure(err));
  }
};

export const rateEventDetail = (id, rating) => async dispatch => {
  const { rateArticleSuccess, rateArticleFailure } = slice.actions;

  try {
    const formData = new FormData();
    formData.append('event', id);
    formData.append('rating', rating);
    await axios.post(ENDPOINTS.GET_EVENTS_VOTE_ENDPOINT, formData);
    dispatch(rateArticleSuccess());
    dispatch(getEventDetail(id, true));
  } catch (err) {
    dispatch(rateArticleFailure(err));
  }
};

export const clearEventsError = () => dispatch => {
  const { clearEventsError } = slice.actions;
  dispatch(clearEventsError());
};

export const resetEventsError = () => async dispatch => {
  const { resetEventsError } = slice.actions;
  dispatch(resetEventsError(null));
};

export const setEventTitle = title => async dispatch => {
  const { setEventTitle } = slice.actions;
  dispatch(setEventTitle(title));
};

export default slice;
